package net.frozenbit.games.soundgame.components

import androidx.compose.animation.core.FastOutSlowInEasing
import androidx.compose.animation.core.RepeatMode
import androidx.compose.animation.core.StartOffset
import androidx.compose.animation.core.animateFloat
import androidx.compose.animation.core.infiniteRepeatable
import androidx.compose.animation.core.rememberInfiniteTransition
import androidx.compose.animation.core.tween
import androidx.compose.foundation.Canvas
import androidx.compose.foundation.layout.aspectRatio
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.runtime.Composable
import androidx.compose.material3.MaterialTheme
import androidx.compose.ui.Modifier
import androidx.compose.ui.geometry.CornerRadius
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.geometry.Size
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp

@Composable
fun AudioWaveForm(
    modifier: Modifier = Modifier,
    barColor: Color = MaterialTheme.colorScheme.primary,
    playing: Boolean = true,
) {
    val transition = rememberInfiniteTransition(label = "audio_wave")
    val barCount = 10
    val barHeights = List(barCount) { index ->
        transition.animateFloat(
            initialValue = 0.25f,
            targetValue = 1f,
            animationSpec = infiniteRepeatable(
                animation = tween(durationMillis = 300 + (index % 3) * 120, easing = FastOutSlowInEasing),
                repeatMode = RepeatMode.Reverse,
                initialStartOffset = StartOffset(index * 90),
            ),
            label = "bar_$index",
        )
    }

    Canvas(
        modifier = Modifier
            .then(modifier),
    ) {
        val spacing = 4.dp.toPx()
        val totalSpacing = spacing * (barCount - 1)
        val barWidth = (size.width - totalSpacing) / barCount
        val minHeight = size.height * 0.05f
        val maxHeight = size.height * 0.8f

        if (playing) {
            barHeights.forEachIndexed { index, barHeight ->
                val height = minHeight + (maxHeight - minHeight) * barHeight.value
                val left = index * (barWidth + spacing)

                drawRect(
                    color = barColor,
                    topLeft = Offset(left, size.height - height),
                    size = Size(barWidth, height),
                )
            }
        } else {
            (0 until barCount).forEach { index ->
                val height = minHeight + (maxHeight - minHeight) * 0
                val left = index * (barWidth + spacing)

                drawRect(
                    color = barColor,
                    topLeft = Offset(left, size.height - height),
                    size = Size(barWidth, height),
                )
            }
        }
    }
}